module.exports = __webpack_public_path__ + "media/11.20e87f42.wav";